import { DestinationRecommendationsData } from '../interfaces/destination';

export const DESTINATION_SCHEMA_PAGE_LIMIT = 10000;
export const DESTINATION_SCHEMA_POLL_INTERVAL = 60000;

export const CREATE_DESTINATION_PROGRESS_STORAGE_KEY = 'destination.general.create.wizard';

export const USER_SETTINGS_QUERY_MANAGED_WAREHOUSE_ALERT_KEY = 'queryManagedWarehouseAlert';

export const DEFAULT_DESTINATION_RECOMMENDATION_SETTINGS: DestinationRecommendationsData = {
  hadRecommendations: false,
  hasPendingRecommendations: false,
  hadAppliedRecommendations: false
};
